<template>
  <div class="crt-overlay">
    <video
      v-if="!isMobile"
      ref="video"
      class="video"
      :style="videoStyle"
      autoplay
      :loop=true
      muted
      src="@/assets/project-synthecite/scanlines_compressed.mp4"
    />
  </div>
</template>

<script>
/**
 * Gives an overlay effect similar to a CRT monitor
 */
import RandomUtils from "@/scripts/utils/random"
import StoreUtils from "@/scripts/utils/store"
import { mapState } from "vuex"
export default {
  data() {
    return {
      videoStyle: "",
      playbackRate: 1,
      storeWatcher: null
    }
  },
  computed: {
    ...mapState(["isMobile"])
  },
  methods: {
    // glitch CRT overlay
    glitch() {
      const videoSpeedPlayRate = 0
      const minOpacity = 0.3
      const maxOpacity = 0.6
      let opacity = RandomUtils.RandomNumber(minOpacity, maxOpacity)
      // glitch for a short amount of time
      this.videoStyle = { opacity: opacity }
      this.$refs.video.playbackRate = videoSpeedPlayRate
    },
    unglitch() {
      // defaults
      this.videoStyle = { opacity: 0.03 }
      this.$refs.video.playbackRate = 0.5
    }
  },
  mounted() {
    if (!this.isMobile) {
      this.unglitch()
      // watch for store change
      this.storeWatcher = StoreUtils.WatchGlitch(this.glitch, this.unglitch)
    }
  },
  beforeDestroy() {
    this.storeWatcher()
  }
}
</script>

<style scoped>
.crt-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%),
    linear-gradient(
      90deg,
      rgba(255, 0, 0, 0.06),
      rgba(0, 255, 0, 0.02),
      rgba(0, 0, 255, 0.06)
    );
  z-index: 2;
  background-size: 100% 2px, 3px, 100%;
  pointer-events: none;
  will-change: transform;
}

.video {
  height: 100%;
  width: 100%;
  object-fit: fill;
}
</style>